import {
  API_METHODS,
  API_URL,
  OperationType,
  PAGE_CONFIG,
} from 'common/constants/sm-constants';
import { SmApiService } from '../../core-services/sm-api.service';
import { SystemService } from '../../core-services/system.service';

import { APIConfig, DataModel } from 'common/models/utility-models/base-model';
import { environment } from 'src/environments/environment';

import {
  editInfo,
  multipleAPIObject,
} from 'common/models/utility-models/utility-interface';

export abstract class DataService<T extends DataModel> {
  constructor(
    protected systemService: SystemService,
    protected ApiUrl: API_URL,
    protected apiService: SmApiService
  ) {}
  abstract createInstance(): T;

  getEditUrlAndMethod(id: any): editInfo {
    const edit = {
      url: environment.apiUrl + this.ApiUrl,
      method: API_METHODS.post,
    };
    return edit;
  }

  getAPI_URL(): API_URL {
    return this.ApiUrl;
  }

  getAPIConfigs() {
    return new APIConfig();
  }

  convertFormData(body) {
    var formData: any = new FormData();
    Object.keys(body).forEach((a) => {
      formData.append(a.toString(), body[a]);
    });

    return formData;
  }

  getUpdateUrl(data = null) {
    return data;
  }

  getDeleteUrl() {
    return '';
  }

  generateUrl(
    type: OperationType,
    paramKey = null,
    extraKey = null,
    data = null
  ) {
    let url;
    // console.log(type, data, 'url type');
    switch (type) {
      case OperationType.CREATE:
        url = environment.apiUrl + this.getAPI_URL();
        break;

      case OperationType.VIEW:
        url = environment.apiUrl + this.getAPI_URL();
        break;
      case OperationType.UPDATE:
        url = environment.apiUrl + this.getUpdateUrl(data);
        break;
      case OperationType.DELETE:
        url = environment.apiUrl + this.getDeleteUrl();
        break;

      default:
        url = environment.apiUrl + this.getAPI_URL();
        break;
    }
    // url = environment.apiUrl + this.ApiUrl;
    return url;
  }

  async getData(initUrl: string = ''): Promise<T[]> {
    // console.log('inside get data')
    return await new Promise<T[]>((resolve, reject) => {
      let url;
      url = initUrl !== '' ? initUrl : this.getCustomUrl(OperationType.VIEW);
      this.apiService
        .getData(url)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  fetchSignedUrl(url): any {
    return this.apiService.fetchSignedUrl(url);
  }

  async getDataByParams(params): Promise<any> {
    return await new Promise((resolve, reject) => {
      const url = this.generateUrl(OperationType.UPDATE);
      this.apiService
        .getDataByParams(url, params)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  

  async postData(data, isFormData: boolean = true): Promise<any> {
    return await new Promise((resolve, reject) => {
      // console.log(data)
      const type = this.getOperationType(data);
      // console.log(type, 'data');
      const url =
        type === OperationType.UPDATE
          ? this.updatepostUrl(type, data)
          : this.generateUrl(type, null, null, data);
      // console.log(url, type, 'data service');
       if (url.includes('/mentorImport/importExcel') || (url.includes('/importMentorMapping/importdata') )) {
        data = this.convertFormData(data);
       }
      this.apiService
        .postData(url, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  updatepostUrl(type: OperationType, data = null) {
    return this.generateUrl(type, data);
  }

  getCustomError() {
    return 'Something went wrong';
  }

  async deleteData(data): Promise<T> {
    return await new Promise((resolve, reject) => {
      let url = this.getDeleteUrl();
      let payload = this.getDeletePayload(data);
      this.apiService
        .postData(url, payload)
        .then((res) => {
          this.initMethod();
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getDeletePayload(data) {
    let payload;
    payload = data;
    return payload;
  }
  async updateGridData(data): Promise<T> {
    return await new Promise((resolve, reject) => {
      const url = environment.apiUrl + this.getStatusUrl();
      const payload = this.getStatusPayload(data);
      this.apiService
        .postData(url, this.convertFormData(payload))
        .then((res) => {
          this.initMethod();

          resolve(JSON.parse(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async updateGridStatusData(data): Promise<T> {
    return await new Promise((resolve, reject) => {
      const url = environment.apiUrl + this.getStatusUrl();
      const payload = this.getStatusPayload(data);
      this.apiService
        .postData(url, payload)
        .then((res) => {
          this.initMethod();

          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getStatusUrl() {
    return '';
  }

  getStatusPayload(data) {
    return '';
  }

  initMethod() {}

  async getDataById(data): Promise<T[]> {
    return await new Promise<T[]>((resolve, reject) => {
      const requestInfo = this.getEditUrlAndMethod(data);
      const url = requestInfo.url;
      switch (requestInfo.method) {
        case API_METHODS.get:
          this.apiService
            .get(url)
            .then((res) => {
              const modifiedResponse = this.modifyAPIResponse(res);
              resolve(modifiedResponse);
            })
            .catch((err) => {
              reject(err);
            });
          break;
        case API_METHODS.post:
          let body = this.getUpdatePayload(data);
          this.apiService
            // .postData(url, this.convertFormData(body))
            .postData(url, body)
            .then((res) => {
              const modifiedResponse = this.modifyAPIResponse(res);
              resolve(modifiedResponse);
            })
            .catch((err) => {
              reject(err);
            });
          break;
      }
    });
  }

  getUpdatePayload(data) {
    let payload;
    payload = {
      id: data.id,
    };
    return payload;
  }

  modifyAPIResponse(response: any) {
    return response['details'];
  }

  async postDataToGridEdit(
    body: any,
    token: any = null,
    customurl: string = ''
  ): Promise<T[]> {
    return await new Promise<T[]>((resolve, reject) => {
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      this.apiService
        .postData(customurl, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async postDataToCustomEndPoint(
    body: any,
    token: any = null,
    customurl: string = '',
    isformdata: boolean = true
  ): Promise<T[]> {
    return await new Promise<T[]>((resolve, reject) => {
      let url;
      url =
        customurl !== null
          ? customurl
          : this.getCustomUrl(OperationType.CREATE);

      const modifiedBody = this.modifyModel(body);
      // console.log(modifiedBody);
      this.apiService
        .postData(url, modifiedBody, token)
        // .postData(url, isformdata === true ? this.convertFormData(modifiedBody) : modifiedBody, token)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async setSystemServiceData(
    dataKeyName,
    apiConstant,
    payload: any = {},
    dataKey: string = '',
    customUrl: string = null
  ): Promise<any> {
    return await new Promise<T[]>((resolve, reject) => {
      let url;
      // + '/' + this.getAPIConfigs['SYSTEMKEY']
      console.log(payload, 'payload')
      customUrl === null
        ? (url = environment.apiUrl + apiConstant)
        : (url = customUrl);
      this.apiService
        .postData(url, this.convertFormData(payload))
        .then((res) => {
          console.log(res, 'res');
          this.systemService['dataStorage'][dataKeyName] = res[dataKey];
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // async validateByUrl(value, extraKey = null): Promise<T[]> {
  //     return await new Promise<T[]>((resolve, reject) => {
  //         const url = this.generateUrl(OperationType.VALIDATE, null, extraKey);
  //         // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  //         this.apiService
  //             .getDataByParams(url, value)
  //             .then(res => {
  //                 resolve(res);
  //             })
  //             .catch(err => {
  //                 reject(err);
  //             });
  //     });
  // }

  apiCallFromMultipleAPI(urlList: string[]) {
    let apiList = [];
    const allPromises = Promise.all(apiList);
    return new Promise((resolve, reject) => {
      allPromises
        .then((data) => {
          const modifiedData = this.modifyMultiModel(data);
          resolve(modifiedData);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  apiCallFromMultipleAPIforGrid(urlList: multipleAPIObject[]) {
    const allPromises = urlList.map((urlItem) => {
      return this.apiService.postData(urlItem.url, urlItem.payload, 'token');
    });

    return new Promise((resolve, reject) => {
      Promise.all(allPromises)
        .then((data) => {
          const modifiedData = this.modifyMultiModel(data);
          resolve(modifiedData);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getOperationType(data: any) {
    // console.log(data)
    const simplifiedData = this.systemService.isFormData(data)
      ? this.systemService.formDataToObject(data)
      : data;
    // console.log(simplifiedData)
    if (simplifiedData.hasOwnProperty('id')) {
      return simplifiedData.id !== ''
        ? OperationType.UPDATE
        : OperationType.CREATE;
    } else {
      return OperationType.CREATE;
    }
  }

  getCustomUrl(operationType: OperationType) {
    return this.generateUrl(operationType);
  }

  getCustomDeleteUrl(operationType: OperationType) {
    return this.generateUrl(operationType);
  }

  getDetailCustomUrl(id: any = null): editInfo {
    const edit = {
      url: '',
      method: API_METHODS.post,
    };
    return edit;
  }

  modifyModel(model) {
    return model;
  }

  modifyMultiModel(model) {
    return model;
  }
}
